import {
  Briefcase,
  File,
  Inbox,
  FileText,
  Building,
  FileSearch,
  FolderOpen,
  FileArchive,
  Library,
  FilePlus,
  Terminal,
  Flag,
  Unlink,
} from "lucide-react";
import { AppColorVariant } from "../../theme/AppColorVariant";

export enum JobEntityType {
  Case = "Case",
  CaseFile = "CaseFile",
  Intake = "Intake",
  IntakeFile = "IntakeFile",
  Provider = "Provider",
  ProviderFile = "ProviderFile",
  FirmDocumentsFolder = "FirmDocumentsFolder",
  FirmDocument = "FirmDocument",
  TemplatesLibrary = "TemplatesLibrary",
  TemplateFile = "TemplateFile",
  SqlScript = "SqlScript",
  FlaggedPath = "FlaggedPath",
  SourceLink = "SourceLink",
}
export const JobEntityTypeLabels: Record<JobEntityType, string> = {
  [JobEntityType.Case]: "Case",
  [JobEntityType.CaseFile]: "Case File",
  [JobEntityType.Intake]: "Intake",
  [JobEntityType.IntakeFile]: "Intake File",
  [JobEntityType.Provider]: "Provider",
  [JobEntityType.ProviderFile]: "Provider File",
  [JobEntityType.FirmDocumentsFolder]: "Firm Documents Folder",
  [JobEntityType.FirmDocument]: "Firm Document",
  [JobEntityType.TemplatesLibrary]: "Templates Library",
  [JobEntityType.TemplateFile]: "Template File",
  [JobEntityType.SqlScript]: "SQL Script",
  [JobEntityType.FlaggedPath]: "Flagged Path",
  [JobEntityType.SourceLink]: "Source Link",
};

export const JobEntityTypeColors: Record<JobEntityType, AppColorVariant> = {
  [JobEntityType.Case]: "primary",
  [JobEntityType.CaseFile]: "primary",
  [JobEntityType.Intake]: "success",
  [JobEntityType.IntakeFile]: "success",
  [JobEntityType.Provider]: "lime",
  [JobEntityType.ProviderFile]: "lime",
  [JobEntityType.FirmDocumentsFolder]: "danger",
  [JobEntityType.FirmDocument]: "danger",
  [JobEntityType.TemplatesLibrary]: "warning",
  [JobEntityType.TemplateFile]: "warning",
  [JobEntityType.SqlScript]: "warning",
  [JobEntityType.FlaggedPath]: "neutral",
  [JobEntityType.SourceLink]: "neutral",
};

export const JobEntityTypeIcons: Record<JobEntityType, React.ElementType> = {
  [JobEntityType.Case]: Briefcase,
  [JobEntityType.CaseFile]: File,
  [JobEntityType.Intake]: Inbox,
  [JobEntityType.IntakeFile]: FileText,
  [JobEntityType.Provider]: Building,
  [JobEntityType.ProviderFile]: FileSearch,
  [JobEntityType.FirmDocumentsFolder]: FolderOpen,
  [JobEntityType.FirmDocument]: FileArchive,
  [JobEntityType.TemplatesLibrary]: Library,
  [JobEntityType.TemplateFile]: FilePlus,
  [JobEntityType.SqlScript]: Terminal,
  [JobEntityType.FlaggedPath]: Flag,
  [JobEntityType.SourceLink]: Unlink,
};
